import useSWR from "swr";

import { HOST_API } from "src/config-global";
import { endpoints, fetcher } from "src/utils/axios";
import type { ProductContentLocale } from "src/types/product-content";
import type {
  OnboardingAccess,
  OnboardingCatalog,
  OnboardingContent,
  OnboardingContext,
  OnboardingFormat,
  OnboardingLength,
} from "src/types/onboarding-content";

export function useOnboardingCatalog(context: OnboardingContext, locale: ProductContentLocale) {
  const params = new URLSearchParams({ context, locale });
  return useSWR<OnboardingCatalog>(`${endpoints.system.onboarding}?${params}`, fetcher, {
    keepPreviousData: false,
    revalidateOnFocus: false,
  });
}

export function useOnboardingContent(
  context: OnboardingContext,
  locale: ProductContentLocale,
  topic: string | null,
  format: OnboardingFormat | null,
  length: OnboardingLength,
  enabled: boolean,
) {
  const params = new URLSearchParams({ context, locale, ...(format ? { format } : {}) });
  if (format === "text") params.set("length", length);
  const key = enabled && topic && format
    ? `${endpoints.system.onboarding}/${encodeURIComponent(topic)}?${params}`
    : null;
  return useSWR<OnboardingContent>(key, fetcher, { keepPreviousData: false, revalidateOnFocus: false });
}

export function useOnboardingAccess(userId: number, providerId: number, enabled: boolean) {
  // Include the actor to prevent a previous account's advisory permissions being reused.
  const key = enabled ? [`/providers/${providerId}/onboarding-access`, { actor: userId }] : null;
  return useSWR<OnboardingAccess>(key, ([url]: [string, { actor: number }]) => fetcher(url), {
    keepPreviousData: false,
  });
}

export function onboardingMediaUrl(path: string) {
  return `${(HOST_API ?? "").replace(/\/$/, "")}${path}`;
}
